import React from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";

export default function Widget() {
  const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <div style={{ backgroundColor: '#f9fafb', padding: '2rem' }}>
      <h2 style={{ fontSize: '2rem', fontWeight: 'bold', textAlign: 'center', marginBottom: '1.5rem' }}>
        Why Travel With The Rustic Paths
      </h2>
      <Slider {...settings}>
        {[{
          icon: "🗺️",
          title: "Nationwide Network Of Local Guides",
          description: "Our extensive network of local guides across India is carefully selected for their deep knowledge of regional cultures, history, and traditions."
        }, {
          icon: "✈️",
          title: "Customized Itineraries For Every Traveler",
          description: "At The Rustic Paths, we understand that every traveler is unique. That’s why we offer tailor-made itineraries that cater to individual preferences."
        }, {
          icon: "🕒",
          title: "24/7 Travel Support On Your Journey",
          description: "Enjoy peace with our 24/7 support, ensuring assistance is always available throughout your journey in India."
        }, {
          icon: "🎉",
          title: "Unmatched Cultural Immersion",
          description: "Experience India like a local with our immersive cultural tours, from participating in traditional festivals to exploring hidden gems."
        }].map((card, index) => (
          <div key={index} style={{ padding: '1.5rem' }}>
            <div style={{
              backgroundColor: '#fff',
              borderRadius: '8px',
              boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
              padding: '1.5rem',
              textAlign: 'center',
              minHeight: '320px', // Ensures all cards have a minimum height
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between'
            }}>
              <div>
                <img alt={`${card.title} Icon`} src={`https://openui.fly.dev/openui/24x24.svg?text=${card.icon}`} style={{ display: 'block', margin: '0 auto 1rem' }} />
                <h3 style={{ fontSize: '1.25rem', fontWeight: '600' }}>{card.title}</h3>
                <p style={{ color: '#6b7280' }}>{card.description}</p>
              </div>
              <a href="/destinations" style={{
                marginTop: '1rem',
                display: 'inline-block',
                backgroundColor: '#3b82f6',
                color: '#fff',
                padding: '0.5rem 1rem',
                borderRadius: '4px',
                textDecoration: 'none'
              }}>
                DISCOVER MORE
              </a>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
}
